import React from 'react';
import {
    Redirect, Route, Switch
} from 'react-router-dom';

import { DashboardRoute } from './dashboard';
import { ROUTES } from './routes';

export const AppRoutes = () => {
    return (
        <Switch>
            <Route
                path={[ROUTES.welcome, ROUTES.contentByModuleId, ROUTES.landingByGroupId]}
                component={DashboardRoute}
            />

            {/* TODO not found route */}
            <Route
                path={'*'}
                exact={true}
                render={() => <Redirect to={ROUTES.welcome} />}
            />
        </Switch>
    );
};
